import * as types from './navbar.actionType';

export default {
  getMenuByPermissions: (userId) => ({
    type: types.GET_MENUBYPERMISSIONS,
    payload: userId,
  }),
  fetchSystemsByUser: () => ({
    type: types.FETCH_SYSTEMSBYUSER,
  }),
  fetchLastAccessByUser: () => ({
    type: types.FETCH_LASTACCESSBYUSER,
  }),
  updatePassword: (password) => ({
    type: types.UPDATE_PASSWORD,
    payload: password,
  }),
  logout: (refreshToken) => ({
    type: types.LOGOUT,
    payload: refreshToken,
  }),
  calculateFavoriteByUrl: (url) => ({
    type: types.GET_FAVORITOS,
    payload: url,
  }),
  iconFavoriteByUrl: (url) => ({
    type: types.ICON_FAVORITOS,
    payload: url,
  }),
  setNotification: (data) => ({
    type: types.SET_NOTIFICATION,
    payload: data,
  }),
  setReadPagesNotification: (data) => ({
    type: types.SET_READPAGES_NOTIFICATION,
    payload: data,
  }),
  getPagesNotification: (page) => ({
    type: types.GET_PAGES_NOTIFICATION,
    payload: page,
  }),
  setPagesNotification: (data) => ({
    type: types.SET_PAGES_NOTIFICATION,
    payload: data,
  }),
  getTotalNotification: () => ({
    type: types.GET_TOTAL_NOTIFICATION,
  }),
  getNewNotification: (notification) => ({
    type: types.GET_NEW_NOTIFICATION,
    payload: notification,
  }),
  readNotification: (notification) => ({
    type: types.GET_READ_NOTIFICATION,
    payload: notification,
  }),
  getAllNotification: (page) => ({
    type: types.GET_ALL_NOTIFICATION,
    payload: page,
  }),
  getAllNotificationGrid: () => ({
    type: types.GET_ALL_NOTIFICATION_GRID,
  }),
  readNotificationGrid: (data) => ({
    type: types.READ_NOTIFICATION_GRID,
    payload: data,
  }),
  unreadNotification: (data) => ({
    type: types.UNREAD_NOTIFICATION,
    payload: data,
  }),
  readAllNotification: () => ({
    type: types.READ_ALL_NOTIFICATION,
  }),
  deleteNotification: (data) => ({
    type: types.DELETE_NOTIFICATION,
    payload: data,
  }),
  toggleMenu: () => ({
    type: types.TOGGLE_MENU,
  }),
  lockMenu: () => ({
    type: types.LOCK_MENU,
  }),
  getInfoAbout: () => ({
    type: types.GET_INFO_ABOUT,
  }),
  updateInfoAbout: (data) => ({
    type: types.UPDATE_INFO_ABOUT,
    payload: data,
  }),
  setFavoritosSelecionados: () => ({
    type: types.SET_FAVORITOS_SELECIONADOS,
    payload: data,
  }),
  removePageFromFavorite: (url) => ({
    type: types.REMOVE_PAGE_FROM_FAVORITE,
    payload: url,
  }),
};
